import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { CustomerForm } from '@/components/customers/CustomerDialog'

export function NewCustomer() {
  const { t } = useTranslation('customers')
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div>
        <Link
          to="/customers"
          className="text-sm text-muted-foreground hover:text-foreground"
        >
          {t('detail.back')}
        </Link>
        <h1 className="mt-1 text-xl font-bold text-slate-900">
          {t('form.title_new')}
        </h1>
        <p className="mt-0.5 text-sm text-slate-500">{t('form.subtitle_new')}</p>
      </div>

      <section className="rounded-xl border border-slate-200 bg-white p-4 sm:p-5">
        <CustomerForm
          onSaved={(id) => navigate(`/customers/${id}`)}
          onCancel={() => navigate('/customers')}
        />
      </section>
    </div>
  )
}
